<template>
  <div class="">
    <section class="title">
      <div class="header__text-box">
        <h1 class="heading-primary">
          <span class="heading-primary--main">Leads Tracker</span>
        </h1>
      </div>
    </section>
    <Crumbs />

    <section class="section-admin">
      <div v-if="leads">
        <el-dialog
          v-if="selectedRow"
          title="Lead"
          :visible.sync="dialogVisible"
          width="50vw"
          height="50vh"
          style="top: 20rem"
          center
        >
          <div>
            Recieved:
            {{ selectedRow.data.date_created.seconds | dateFilter }}
          </div>
          <div>Email: {{ selectedRow.data.email }}</div>
          <div>Message: {{ selectedRow.data.message }}</div>
          <span
            slot="footer"
            class="dialog-footer"
          >
            <button
              type="button"
              class="btn btn-tiled quaternary"
            >
              Send Email
            </button>
            <button
              type="button"
              :class="[
                getStatus(selectedRow)
                  ? ['btn', 'btn-tiled', 'quaternary']
                  : ['btn', 'btn-tiled', 'primary']
              ]"
              @click.prevent="handleArchive(selectedRow.index, selectedRow)"
            >
              Flag: <span v-if="archiveStatus">Unarchive</span> <span v-if="!archiveStatus">Archive</span>
            </button>
            <button
              type="button"
              :class="[
                getResponse(selectedRow)
                  ? ['btn', 'btn-tiled', 'primary']
                  :['btn', 'btn-tiled', 'quaternary']
              ]"
              @click.prevent="handleResponse(selectedRow.index, selectedRow)"
            >          
              Flag: <span v-if="messageStatus">Send Message</span> <span v-if="!messageStatus">Message Sent</span>
            </button>
            <button
              type="button"
              class="btn btn-tiled secondary"
              @click.prevent="dialogVisible = false"
            >
              Cancel
            </button>
            <button
              type="button"
              class="btn btn-tiled secondary"
              @click.prevent="dialogVisible = false"
            >
              Delete
            </button>
          </span>
        </el-dialog>
  
        <el-table
          ref="filterTable"
          :data="
            leads.filter(
              data =>
                !search ||
                data.data.message.toLowerCase().includes(search.toLowerCase())
            )
          "
          :default-sort="{
            prop: 'data.date_created.seconds',
            order: 'descending'
          }"
          @selection-change="handleSelectionChange"
        >
          <el-table-column
            type="selection"
            width="55"
          />
          <el-table-column
            label="Date"
            sortable
            prop="data.date_created.seconds"
            :formatter="dateFormatter"
            width="180"
            column-key="date"
          />
          <el-table-column
            label="Message"
            sortable
            prop="data.message"
          />
          <el-table-column
            label="Email"
            sortable
            prop="data.email"
          />
          <el-table-column
            label="Reason"
            sortable
            prop="data.reason"
            column-key="data.reason"
            :filters="[
              { text: 'Machine Learning', value: 'Machine Learning' },
              { text: 'Website Design', value: 'Website Design' }
            ]"
            :filter-method="filterReason"
          >
            <template slot-scope="scope">
              <el-tag
                :type="
                  scope.row.data.reason === 'Machine Learning'
                    ? 'warning'
                    : 'success'
                "
                disable-transitions
                effect="dark"
              >
                {{ scope.row.data.reason }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column
            label="Response"
            :formatter="responseFormatter"
            sortable
            prop="data.response"
            column-key="data.response"
            :filters="[
              { text: 'Message Sent', value: 1 },
              { text: 'Send Message', value: 0 }
            ]"
            :filter-method="filterResponse"
          >
            <template slot-scope="scope">
              <a :href="'mailto:' + scope.row.data.email + '?&bcc=afletcher53@gmail.com&subject=RE: ' + scope.row.data.reason + ' - Your recently enquiry to Aaron Fletcher Designs&body=You recently enquired to Aaron Fletcher Designs'">
                <el-tag
                  :type="scope.row.data.response === 0 ? 'primary' : 'success'"
                  disable-transitions
                >
                  {{ responseFormatter(scope.row) }}
                </el-tag>
              </a>
            </template>
          </el-table-column>
          <el-table-column
            label="Status"
            sortable
            prop="data.status"
            column-key="data.status"
            
            :filters="[
              { text: 'Live', value: 0 },
              { text: 'Archived', value: 1 }
            ]"
            :filter-method="filterStatus"
          >
            <template slot-scope="scope">
              <el-tag
                :type="
                  scope.row.data.status === 0
                    ? 'success'
                    : 'danger'
                "
                disable-transitions
                effect="dark"
              >
                {{ statusFormatter(scope.row) }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column
            label="Lapsed"
            prop="data.date_created.seconds"
            :formatter="lapsedFormatter"
            sortable
          />
          <el-table-column align="right">
            <template
              slot="header"
              slot-scope="{}"
            >
              <el-input
                v-model="search"
                size="mini"
                placeholder="Type to search"
              />
            </template>

            <template slot-scope="scope">
              <button
                type="button"
                class="btn btn-tiled secondary"
                style="width: 20px;  padding:0.5rem; width:max-content; margin:auto; margin-right: 0.5rem;"
                @click.prevent="handleView(scope.$index, scope.row)"
              >
                <i
                  class="fa fa-search"
                  aria-hidden="true"
                />
              </button>
              <button
                type="button"
                :class="[
                  getStatus(scope.row)
                    ? ['btn', 'btn-tiled', 'quaternary']
                    : ['btn', 'btn-tiled', 'primary']
                ]"
                style="width: 20px;  padding:0.5rem; width:max-content; margin:auto; margin-right: 0.5rem;"
                @click.prevent="handleArchive(scope.$index, scope.row)"
              >
                <i
                  class="fa fa-archive"
                  aria-hidden="true"
                />
              </button>
              <button
                type="button"
                class="btn btn-tiled tertiary"
                style="width: 20px; padding:0.5rem; width:max-content; margin:auto;"
                @click.prevent="handleDelete(scope.$index, scope.row)"
              >
                <i
                  class="fa fa-trash"
                  aria-hidden="true"
                />
              </button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div
        class="table__actions"
        style="margin-top:1rem;"
      >
        <div class="dropdown">
          <button class="dropbtn">
            Actions
            <span
              class="dropbtn__right-chevron"
            ><i
              class="fa fa-chevron-right"
            /></span>
            <div class="dropdown-content">
              <span>
                <button
                  type="button"
                  class="btn btn-tiled quaternary"
                  @click.prevent="handleGroupDelete"
                >
                  Delete
                </button>
              </span>

              <span>
                <button
                  type="button"
                  class="btn btn-tiled quaternary"
                  @click.prevent="handleGroupArchive"
                >
                  Toggle Archive
                </button>
              </span>
              <span>
                <button
                  type="button"
                  class="btn btn-tiled quaternary"
                  @click="handleGroupResponseSent"
                >
                  Toggle Reponse
                </button>
              </span>
              <span>
                <button
                  type="button"
                  class="btn btn-tiled quaternary"
                  @click="clearFilter"
                />
              </span>
            </div>
          </button>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import Crumbs from "@/components/layout/Crumbs";
import {
  getFirebaseCollection,
  updateFirebaseDocument,
  deleteFirebaseDocument
} from "@/functions/firebase/base";
export default {
  name: "Leads",
  components: {
    Crumbs
  },
  data() {
    return {
      leads: null,
      dataLoaded: null,
      search: "",
      dialogVisible: false,
      multipleSelection: [],
      testSelection: [],
      selectedRow: null
    };
  },
  computed: {
    // a computed getter
    messageStatus: function () {
      // `this` points to the vm instance
      if(this.selectedRow.data.response === 1){
        return true
      } else {
        return false
      }
    },
    archiveStatus: function () {
      // `this` points to the vm instance
      if(this.selectedRow.data.status === 1){
        return true
      } else {
        return false
      }
    }
  },
  mounted() {
    getFirebaseCollection(process.env.VUE_APP_DB_LEADS)
      .then(result => (this.leads = result))
      .then(() => {
        this.dataLoaded === true;
      });
  },
  methods: {
    handleView(index, row) {
      console.log(index);
      console.log(index, row);
      this.selectedRow = row;
      this.selectedRow.index = index;
      this.dialogVisible = true;
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
      this.testSelection = this.multipleSelection;
    },
    getStatus(row) {
      if (row.data.status === 1) {
        return true;
      } else {
        return false;
      }
    },
    getResponse(row) {
      if (row.data.response === 1) {
        return true;
      } else {
        return false;
      }
    },
    statusFormatter(row) {
      if (row.data.status === 0) {
        return "Live";
      }
      if (row.data.status === 1) {
        return "Archived";
      }
    },
    responseFormatter(row) {
      if (row.data.response === 0) {
        return "Send Message";
      }
      if (row.data.response === 1) {
        return "Message Sent";
      }
    },
    lapsedFormatter(row) {
      var date1 = new Date(row.data.date_created.seconds * 1000);
      var date2 = new Date();
      var diff = date2.getTime() - date1.getTime();
      var Difference_In_Days = diff / (1000 * 3600 * 24);
      return Math.round(Difference_In_Days, 0) + " days";
    },
    dateFormatter(row) {
      return this.$options.filters.dateFilter(row.data.date_created.seconds);
    },
    archiveFormatter(row) {
      if (row.data.status === 0) {
        return "Unarchived Lead";
      }
      if (row.data.status === 1) {
        return "Archived Lead";
      }
    },
    filterHandler(value, row, column) {
      const property = column["property"];
      console.log(property);
      return row[property] === value;
    },
    filterResponse(value, row) {
      console.log(row.data.response, value);
      return row.data.response === value;
    },
    filterReason(value, row) {
      console.log(row.data.response, value);
      return row.data.reason === value;
    },
      filterStatus(value, row) {
      console.log(row.data.status, value);
      return row.data.status === value;
    },
    clearFilter() {
      this.$refs.filterTable.clearFilter();
      console.log("all filters removed");
    },
    handleResponse(index, row) {
      console.log(index, row);
       if (row.data.response === 1) {
        updateFirebaseDocument(
          process.env.VUE_APP_DB_LEADS,
          row.id,
          "response",
          0
        ).then(() => {
          this.leads[index].data.response = 0;
        });
      } else {
        updateFirebaseDocument(
          process.env.VUE_APP_DB_LEADS,
          row.id,
          "response",
          1
        ).then(() => {
          this.leads[index].data.response = 1;
        });
      }
    },
    handleGroupDelete(){
      this.multipleSelection.forEach((val, index) =>
      {
         var multipleIndex = this.leads.map(x => x.data).indexOf(val.data)
          this.handleDelete(multipleIndex, val)
      })
    },
    handleGroupArchive(){
     this.multipleSelection.forEach((val, index) =>
      {
         var multipleIndex = this.leads.map(x => x.data).indexOf(val.data)
          this.handleArchive(multipleIndex, val)
      })
    },
    handleGroupResponseSent(){
      this.multipleSelection.forEach((val, index) =>
      {
         var multipleIndex = this.leads.map(x => x.data).indexOf(val.data)
          this.handleSend(multipleIndex, val)
      })
    },
    handleDelete (index, row) {
      console.log(index, row);
      deleteFirebaseDocument(process.env.VUE_APP_DB_LEADS, row.id) 
      this.leads.splice(index, 1);
    },
    handleSend(index, row){
      console.log(index, row);
      if (row.data.response === 1) {
        updateFirebaseDocument(
          process.env.VUE_APP_DB_LEADS,
          row.id,
          "response",
          0
        ).then(() => {
          this.leads[index].data.response = 0;
        });
      } else {
        updateFirebaseDocument(
          process.env.VUE_APP_DB_LEADS,
          row.id,
          "response",
          1
        ).then(() => {
          this.leads[index].data.response = 1;
        });
      }
    },
    handleArchive(index, row) {
      console.log(index, row);
      if (row.data.status === 1) {
        updateFirebaseDocument(
          process.env.VUE_APP_DB_LEADS,
          row.id,
          "status",
          0
        ).then(() => {
          this.leads[index].data.status = 0;
        });
      } else {
        updateFirebaseDocument(
          process.env.VUE_APP_DB_LEADS,
          row.id,
          "status",
          1
        ).then(() => {
          this.leads[index].data.status = 1;
        });
      }
    }
  }
};
</script>
